module.exports = __webpack_public_path__ + "static/media/brazil_covid_art_crafts_getty_mobile.b6cb1087.jpg";